import { render, staticRenderFns } from "./StatusLogs.vue?vue&type=template&id=18daa55f&scoped=true"
import script from "./StatusLogs.vue?vue&type=script&lang=js"
export * from "./StatusLogs.vue?vue&type=script&lang=js"
import style0 from "./StatusLogs.vue?vue&type=style&index=0&id=18daa55f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18daa55f",
  null
  
)

export default component.exports